const APIS = {
  DELIVERY_PARTNER: "/deliveryservice/api/delivery-partner-configurations/",
  ORDER: "/deliveryservice/api/order/",
  STATUS: "/deliveryservice/api/status/",
  MERCHANT: "/logisticservice/api/merchant/",
  LOCATION: "/deliveryservice/api/location/",
  LOCATIONS: "/logisticservice/api/location/",
  SENDER_LOCATION: "/productservice/api/location",
  BRANCH: "/deliveryservice/api/branch/",
  BRANCHS: "/logisticservice/api/branch/",
};

export default APIS;
